import { createSelector } from 'reselect';
import { Set } from 'immutable';

// Types
import { CalendarMeeting } from 'Shared/types/CalendarMeeting.type';

// Constants
import CalendarMeetingsConstants from 'Shared/constants/CalendarMeetings.constants';

const getCalendarMeetings = state => state.calendarMeetings;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getDayParam = createParameterSelector(params => params.day);
const getIdParam = createParameterSelector(params => params.id);

export const getAllCalendarMeetings = createSelector([getCalendarMeetings], calendarMeetings => {
  return calendarMeetings.get(CalendarMeetingsConstants.State.CALENDAR_MEETINGS_BY_ID);
});

export const getCalendarMeetingIdsForDay = createSelector(
  [getCalendarMeetings, getDayParam],
  (calendarMeetings, day) => {
    return calendarMeetings.getIn([CalendarMeetingsConstants.State.CALENDAR_MEETINGS_IDS_BY_DAY, day], Set());
  }
);

export const getCalendarMeetingById = createSelector([getAllCalendarMeetings, getIdParam], (calendarMeetings, id) => {
  return (
    (calendarMeetings.find(meeting => meeting.get('id') === id).toJS() as CalendarMeeting) || ({} as CalendarMeeting)
  );
});

export const getCalendarMeetingsByDay = createSelector(
  [getAllCalendarMeetings, getCalendarMeetingIdsForDay],
  (calendarMeetings, ids) => {
    return calendarMeetings
      .filter(event => ids.includes(event.get('id')))
      .sortBy(event => event.get('startTime'))
      .valueSeq()
      .toJS() as CalendarMeeting[];
  }
);
